import { Link } from "react-router-dom";

export default function CTABanner({
  headline = "Ready for a clearer property strategy?",
  subcopy = "Book a complimentary, no-obligation consultation. Bring your questions — we will work through them together.",
}) {
  return (
    <section className="bg-white py-20 md:py-28" data-testid="cta-banner">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative bg-[#fffbea] border border-[#ffde59]/50 rounded-3xl p-10 md:p-16 overflow-hidden">
          <div className="absolute -top-16 -right-16 h-48 w-48 rounded-full bg-[#ffde59]/30 blur-3xl pointer-events-none" />
          <div className="relative grid lg:grid-cols-[1.5fr,1fr] gap-10 items-center">
            <div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-[#0a2540]/60 font-semibold mb-4">
                Personal Advisory
              </div>
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#0a2540] leading-[1.1]">
                {headline}
              </h2>
              <p className="mt-5 text-base text-slate-600 leading-relaxed max-w-2xl">
                {subcopy}
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <Link
                to="/contact"
                data-testid="cta-banner-schedule"
                className="inline-flex items-center justify-center gap-2 bg-[#ffde59] text-[#023e8a] px-7 py-4 font-semibold text-base rounded-full hover:shadow-xl hover:-translate-y-0.5 transition-all"
              >
                Schedule an Appointment
                <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
              </Link>
              <Link
                to="/framework"
                data-testid="cta-banner-framework"
                className="inline-flex items-center justify-center gap-2 border border-[#0a2540]/20 text-[#0a2540] px-7 py-4 font-medium text-base rounded-full hover:border-[#0a2540] transition-all"
              >
                Explore the Framework
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
